import * as core from '../../../../../../../core'
import * as stakeholderTrainingAudience from '../stakeholder-training-audience'

export const RESOURCE = {
  payload: {
    description: 'Job Aid / Performance Support',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderTrainingAudience.RESOURCE.payload.partialId,
    }),
    id: 'Job Aid / Performance Support',
    name: 'Job Aid / Performance Support',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
